<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Row>
        <ColumnUi md="9">
          <Title tag="h1" v-if="subprogram">{{ subprogram.title }}</Title>
          <Title tag="h1" v-else>Subprograma no encontrado</Title>
          <Content v-if="content" :content="content" />
          <p v-else>No hay contenido disponible para este subprograma</p>
        </ColumnUi>
        <ColumnUi md="3">
          <Title tag="h3" theme="normal"><b>En esta sección</b></Title>
          <List marked>
            <li v-for="(subp, index) in subprograms" :key="index">
              <router-link
                v-if="!subprogram || subprogram.slug != subp.slug"
                :to="`/subprogramas/${subp.slug}`"
              >
                {{ subp.title }}
              </router-link>
              <span v-else>
                {{ subp.title }}
              </span>
            </li>
          </List>
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>
<script>
import programs from "@/data.js";
import Container from "@/components/ui/objects/Container";
import List from "@/components/ui/objects/List.vue";
import Row from "@/components/ui/atoms/Row.vue";
import ColumnUi from "@/components/ui/atoms/ColumnUi.vue";
import Trail from "@/components/common/Trail.vue";
import Title from "@/components/ui/atoms/Title.vue";
import { useRoute } from "vue-router";
import Content from "@/components/common/Content.vue";

export default {
  components: {
    Trail,
    Container,
    Row,
    ColumnUi,
    List,
    Title,
    Content
  },
  setup() {
    const subprograms = programs[process.env.VUE_APP_PREFIX].subprograms;
    const route = useRoute().params.subprogram;
    const subprogram = subprograms.find(subprogram => subprogram.slug == route);
    const content = subprogram && subprogram.content;

    return {
      subprogram,
      content,
      subprograms
    };
  }
};
</script>
